export const defaultSignaturePadOptions: Record<string, any> = {
  canvasWidth: 245,
  canvasHeight: 107,
} as const;
